import { render, staticRenderFns } from "./shipping-zones-rates-modal.vue?vue&type=template&id=27c95455&"
import script from "./shipping-zones-rates-modal.vue?vue&type=script&lang=js&"
export * from "./shipping-zones-rates-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports